export enum ReportClassType {
    "GENERAL",
    "CONTENT",
    "USER",
}

export type ReportReason = {
    id: number;
    name: string;
};

export type ReportPayload = {
    reportClassificationId: string;
};
